import request from '@/utils/request';

export function getApplyList(data) {
  return request({
    url: `/sc-basic-merchant-backend/settlement/apply/list`,
    method: "post",
    data,
  });
}

export function getVendorList() {
  return request({
    url: `/sc-basic-merchant-backend/seller/vendor/list`,
    method: "get",
  });
}

export function updateSettlementApply(data) {
  return request({
    url: `/sc-basic-merchant-backend/settlement/apply/update`,
    method: "post",
    data,
  });
}

export function batchUpdateSettlementApply(data) {
  return request({
    url: `/sc-basic-merchant-backend/settlement/apply/batch/update`,
    method: "post",
    data,
  });
}



export function getExceptionList() {
  return request({
    url: `/sc-basic-merchant-backend/settlement/apply/exception/list`,
    method: "get",
  });
}

export function exportSettlementApply(data) {
  return request({
    url: `/sc-basic-merchant-backend/settlement/apply/export`,
    method: "post",
    data,
  });
}

export function downloadSample() {
  return request({
    url: `/sc-basic-merchant-backend/settlement/apply/sample`,
    method: "get",
    responseType: 'blob',
  });
}

export function importSettlementApply(data, params) {
  return request({
    url: `/sc-basic-merchant-backend/settlement/apply/import`,
    method: "post",
    data,
    params,
  });
}

export async function voucherUpload(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/settlement/apply/voucherUpload`,
    method: "post",
    data
  })).data;
}

export async function exportSettlementResult() {
  return (await request({
    url: `/sc-basic-merchant-backend/settlement/apply/export/result`,
  })).data;
}
